function ensureLeadingSlash(url) {
    if (!url.startsWith('/')) {
        return '/' + url;
    }

    return url;
}

function prefixTo(to, prefix) {
    if (!to) {
        return prefix;
    }

    if (typeof to === 'object') {
        return {
            ...to,
            pathname: urlCombine(prefix, to.pathname),
        };
    } else {
        return urlCombine(prefix, to);
    }
}

function urlCombine(...parts) {
    if (parts.length === 0) {
        return '';
    }

    const startsWithSlash = parts[0].startsWith('/');

    let url = parts.map((part) => part.replace(/(^\/)|(\/$)/, '')).join('/');

    if (startsWithSlash) {
        url = ensureLeadingSlash(url);
    }

    return url;
}

export { prefixTo, ensureLeadingSlash };